import { motion } from "framer-motion";

interface PageHeaderProps {
  title: string;
  subheader?: string;
  isNotService?: boolean;
}


/* -------------------------------
   Animation Variants
-------------------------------- */

const dividerVariants = {
  initial: { scaleX: 0 },
  animate: { scaleX: 1 },
  exit: { scaleX: 0,
    transition: {
      duration: 0.4,
      ease: "easeInOut" as const,
      delay: 0.55,
    }},
};

/* -------------------------------
   Component
-------------------------------- */

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subheader,
  isNotService = false,
}) => {
  return (
    <section className="relative overflow-hidden text-[#0B2545] ml-[4rem]">
      {/* CONTENT */}
      <div className="relative mx-auto max-w-5xl px-6 -ml-[4rem]">
        {/* TITLE */}
        <motion.h1
          className="
            text-lg
            whitespace-nowrap
            ml-24
            md:ml-[120px]
            lg:ml-[184px]
            xl:ml-[16.5rem]
            laptop:ml-[16.5rem]
            desktop:ml-[16.5rem]
            widescreen:ml-[16.5rem]
            md:text-4xl
            font-semibold
            tracking-tight
            translate-y-[200px]
            pt-[80px]
            pb-[0px]
          "
          initial={{ opacity: 0, y: 28 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{
                opacity: 0,
                y: 28,
                transition: {
                duration: 0.35,
                ease: [0.4, 0, 1, 1],
                delay: 0.50
                },
            }}
            transition={{
                duration: 0.5,
                ease: [0.16, 1, 0.3, 1],
                delay: 0.85,
            }}
        >
          {title}
        </motion.h1>


      </div>

      {/* DIVIDER */}
      <motion.div
        className={
          isNotService
            ? "origin-left h-px bg-black md:ml-[5rem] lg:ml-[9rem] laptop:ml-[14rem] desktop:ml-[14rem] md:mr-24 lg:mr-[8rem] laptop:mr-[16rem] desktop:mr-[16rem]"
            : "origin-left h-px bg-black md:ml-[2rem] md:mr-[6rem] lg:mr-[8rem] laptop:mr-[16rem] desktop:mr-[16rem]"
        }
         variants={dividerVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{
            duration: 0.6,
            ease: "easeInOut",
        }}
        custom={true}
      />
    </section>
  );
};

export default PageHeader;
